import script from "./CModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./CModal.vue?vue&type=script&lang=ts&setup=true"

import "./CModal.vue?vue&type=style&index=0&id=70b06e26&scoped=true&lang=scss"

import exportComponent from "../../../../../../ldplatform/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-70b06e26"]])

export default __exports__